import * as environment from '../config/environment';
import { BaseAPI } from './BaseAPI';

class IkIslemleriAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "IkIslemleri";
        super(baseUrl);
    }

    memIzınBilgiDurumList(request: MemIzınBilgiDurumListRequest) {
        return this.get("MemIzınBilgiDurumList", { params: request });
    }

    ismIzınBilgiDurumList(request: IsmIzınBilgiDurumListRequest) {
        return this.get("IsmIzınBilgiDurumList", { params: request });
    }

    perAileDurumBilgiList(request: PerAileDurumBilgiListRequest) {
        return this.get("PerAileDurumBilgiList", { params: request });
    }

    perIzinRaporBilgiList(request: PerIzinRaporBilgiListRequest) {
        return this.get("PerIzinRaporBilgiList", { params: request });
    }

    perSicilZimmetList(request: PerSicilZimmetListRequest) {
        return this.get("PerSicilZimmetList", { params: request });
    }

    getPersonelDetay(request: GetPersonelDetayRequest) {
        return this.get("GetPersonelDetay", { params: request });
    }

}
export default new IkIslemleriAPI();

class MemIzınBilgiDurumListRequest {
    qtSicilId?: number;
    dtIslemTarihi?: Date;
    rowCount?: number;

    constructor(
        qtSicilId?: number,
        dtIslemTarihi?: Date,
        rowCount?: number
    ) {
        this.qtSicilId = qtSicilId;
        this.dtIslemTarihi = dtIslemTarihi;
        this.rowCount = rowCount;
    }
}
export { MemIzınBilgiDurumListRequest };

class IsmIzınBilgiDurumListRequest {
    qtSicilId?: number;
    dtIslemTarihi?: Date;
    rowCount?: number;

    constructor(
        qtSicilId?: number,
        dtIslemTarihi?: Date,
        rowCount?: number
    ) {
        this.qtSicilId = qtSicilId;
        this.dtIslemTarihi = dtIslemTarihi;
        this.rowCount = rowCount;
    }
}
export { IsmIzınBilgiDurumListRequest };

class PerAileDurumBilgiListRequest {
    rfPerSicilBilgi?: number;

    constructor(
        rfPerSicilBilgi?: number
    ) {
        this.rfPerSicilBilgi = rfPerSicilBilgi;
    }
}
export { PerAileDurumBilgiListRequest };

class PerIzinRaporBilgiListRequest {
    qtSicilId?: number;
    ctTur?: number;

    constructor(
        qtSicilId?: number,
        ctTur?: number
    ) {
        this.qtSicilId = qtSicilId;
        this.ctTur = ctTur;
    }
}
export { PerIzinRaporBilgiListRequest };

class PerSicilZimmetListRequest {
    qtSicilId?: number;
    personelTur?: number;

    constructor(
        qtSicilId?: number,
        personelTur?: number
    ) {
        this.qtSicilId = qtSicilId;
        this.personelTur = personelTur;
    }
}
export { PerSicilZimmetListRequest };

class GetPersonelDetayRequest {
    sicilKodu?: string;
    personelTipi?: string;

    constructor(
        sicilKodu?: string,
        personelTipi?: string
    ) {
        this.sicilKodu = sicilKodu;
        this.personelTipi = personelTipi;
    }
}
export { GetPersonelDetayRequest };